import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    page403_oops: 'Упс, Отказано в доступе!',
    page403_access: 'У вас нет прав для посещения этой страницы.',
    page403_toHome: 'на главную'
  },kk:{
    page403_oops: 'Упс, қолжетімділіктен бас тартылған!',
    page403_access: 'Бұл бетке кіру үшін құқықтарыңыз жоқ.',
    page403_toHome: 'басты бетке',
  }
});
